import {
  Modal,
  type ModalProps,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import { Button } from "../../../shared/Button/Button";
import { FormProvider, useController, useForm } from "react-hook-form";
import { useEffect, useMemo, useState } from "react";
import { useGetApi } from "../../../../hooks";

// interface Props extends ModalProps{ }
const useFormFields = (control: any) => {
  const roleName = useController({ name: "roleName", control });
  const userType = useController({ name: "userType", control });
  const client = useController({ name: "client", control });
  const yacht = useController({ name: "yacht", control });
  const description = useController({ name: "description", control });

  return { roleName, userType, client, yacht, description };
};
const AddCrewRoleModal = ({ opened, onClose }: ModalProps) => {
  const [yachts, setYachts] = useState([]);

  // const {yachts}=useGetAllYachts

  const methods = useForm({
    defaultValues: {
      roleName: "",
      userType: "1",
      client: "*",
      yacht: "*",
      description: "",
    },
  });

  const { handleSubmit, control, watch, setValue, reset } = methods;
  const { roleName, userType, client, yacht, description } =
    useFormFields(control);

  const selectedClient = watch("client");

  const { data: clientsData } = useGetApi<{
    data: { content: { list: any[] } };
  }>({
    request: "get-management",
    body: { _sect: "_clients" },
  });

  const parsedClients = useMemo(() => {
    if (!clientsData?.data?.content?.list) return [];

    const list = clientsData.data.content.list.map((el: any) => ({
      label: el.clientname,
      value: el.clid,
    }));
    list.unshift({ label: "All", value: "*" });

    return list;
  }, [clientsData]);

  const fetchAvailableYachts = async (client: string) => {
    // fetch yachts for a client
  };

  useEffect(() => {
    if (selectedClient) {
      void fetchAvailableYachts(selectedClient);
      setValue("yacht", "");
    }
  }, [selectedClient]);

  const onSubmit = (data: any) => {
    console.log(data);
  };

  const handleClose = () => {
    onClose();
    reset();
  };

  return (
    <Modal opened={opened} onClose={handleClose} title="Add Crew Role">
      <FormProvider {...methods}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
          }}>
          <TextInput label="Enter a role name" {...roleName.field} />
          <Select
            label="Select Usertype"
            data={[
              { label: "Yacht Admin", value: "0" },
              { label: "Yacht Users", value: "1" },
            ]}
            {...userType.field}
          />
          <Select
            label="Select Client"
            data={parsedClients}
            {...client.field}
          />
          <Select label="Select Yacht" data={yachts} {...yacht.field} />
          <Textarea label="Enter a role description" {...description.field} />
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              gap: 10,
              marginTop: 20,
            }}>
            <Button color="red">Cancel</Button>
            <Button type="submit">Submit</Button>
          </div>
        </form>
      </FormProvider>
    </Modal>
  );
};
export default AddCrewRoleModal;
